<template>
    <span class="m-r-10 ">
        <el-button
            @click="openDialog()"
            :disabled="!cheked"
            >
            <i class="el-icon-edit m-r-20"></i>Редактировать
        </el-button>
        <el-dialog title="Подтвердите действие" :visible.sync="dialogTableVisible" :close-on-click-modal="false" width="50%">
            <el-form :model="form" :rules="rules" ref="form" label-position="left" label-width="150px" >
                <el-form-item label="Введите новое имя" prop="title">
                    <el-input size="small" v-model="form.title"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    size="mini"
                    @click="dialogTableVisible = false"
                >
                    Отменить
                    </el-button>
                <el-button
                    size="mini"
                    type="primary"
                    @click="editItem"
                >
                    Сохранить
                    </el-button>
            </span>
        </el-dialog>
    </span>
</template>

<script>

export default {
    data() {
        return {
            dialogTableVisible: false,
            form: {
                title: '',
            },
            rules: {
				title: [
					{ required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
				],
            }
        }
    },
    props: {
        catalogId: {
            default: null,
            type: Object
        },
        cheked: {
            default: null,
            type: Object
        },
    },
    computed: {

    },
    methods: {

        openDialog() {
            this.dialogTableVisible = true
            this.form.title = this.cheked.label || ''
        },

        closeDialog() {
            this.dialogTableVisible = false
        },

        async editItem() {
            this.$emit('editDocument', this.form.title)
        }
           
        


    }
}
</script>



